/**
 * Family Sharing API service for Pro features
 */

import api from './api';

const familyService = {
  // Create a new family group (Pro feature)
  async createFamily(familyName) {
    try {
      const response = await api.post('/family', { name: familyName });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to create family');
    }
  },

  // Get family information
  async getFamilyInfo() {
    try {
      const response = await api.get('/family/info');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get family info');
    }
  },

  // Invite a family member
  async inviteMember(familyId, email, role = 'member') {
    try {
      const response = await api.post('/family/invite', {
        family_id: familyId,
        email,
        role
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to invite family member');
    }
  },

  // Share a box with family
  async shareBox(boxId, permissionLevel = 'view') {
    try {
      const response = await api.post('/family/share-box', {
        box_id: boxId,
        permission_level: permissionLevel
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to share box');
    }
  },

  // Accept a family invitation
  async acceptInvitation(token) {
    try {
      const response = await api.post('/family/accept-invitation', {
        token
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to accept invitation');
    }
  },

  // Remove a family member
  async removeMember(familyId, memberId) {
    try {
      const response = await api.post('/family/remove-member', {
        family_id: familyId,
        member_id: memberId
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to remove member');
    }
  },

  // Unshare a box from family
  async unshareBox(boxId) {
    try {
      const response = await api.post('/family/unshare-box', {
        box_id: boxId
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to unshare box');
    }
  },

  // Get all shared boxes
  async getSharedBoxes() {
    try {
      const response = await api.get('/family/shared-boxes');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get shared boxes');
    }
  }
};

export default familyService;
